import { ConfigProvider, Drawer, Dropdown } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";
import { DownOutlined } from "@ant-design/icons";
import useNotificationStore from "../../stores/useNotificationStore";
import { Spin } from "antd";
import useNotificationDataLoader from "../../hooks/useNotificatioDataLoader";
import { navToNotificationDetails } from "../../services/notification-service";
import TopNavMenu from "./TopNavMenu";
import NotificationComponent from "../common/NotificationComponent";
import { prepareUserDataOnLeaveRestaurant } from "../../services/super-admin/restaurant-switch-service";
import { useClearSessionData } from "../../hooks/useClearSessionData";

function Header({ title, menu, currentMenuKey, record, callback }) {
  const {
    isLoggedIn,
    user,
    isSuperAdmin,
    restaurantId,
    restaurantName,
    branches,
    restaurantSlug,
    restaurantLogo,
    totalTableInRestaurant,
    isReloadNeeded,
    changeBranch,
    setIsReloadNeeded,
    setNetworkCall,
    setUser,
  } = useUserStore();
  const [openDrawer, setOpenDrawer] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [placement, setPlacement] = useState("right");
  const [branch, setBranch] = useState([]);
  const navigate = useNavigate();
  const { hasNewNotification, setHasNewNotification } = useNotificationStore();
  const {
    notificationInitLoader,
    notficationLoadMoreLoader,
    notificationRecords,
    notificationListPageNo,
    hasMoreNotifications,
    loadNotificationData,
    markAsReadNotification,
  } = useNotificationDataLoader();
  const clearSessionData = useClearSessionData();

  const logout = async () => {
    try {
      const token = user.token.token;
      setNetworkCall(true);
      clearSessionData();
      await ApiService.LOGOUT({}, token);
    } catch (err) {
      console.error("---logout error--", err);
    } finally {
      setNetworkCall(false);
      navigate("/login");
    }
  };

  const items = [];

  if (!user?.isSuperAdmin) {
    items.push({
      key: "1",
      label: (
        <div className="font-uregular text-md w-full" onClick={() => onMenuClick("profile")}>
          Profile
        </div>
      ),
    });

    items.push({
      key: "3",
      label: (
        <div className="font-uregular text-md w-full" onClick={() => onMenuClick("printer-settings")}>
          Printer Settings
        </div>
      ),
    });

    items.push({
      key: "5",
      label: (
        <div className="font-uregular text-md w-full" onClick={() => onMenuClick("coupon-settings")}>
          Coupon Settings
        </div>
      ),
    });

    items.push({
      key: "7",
      label: (
        <div className="font-uregular text-md w-full" onClick={() => onMenuClick("change-password")}>
          Change Password
        </div>
      ),
    });
  }

  if (user?.isSuperAdmin) {
    items.push({
      key: "9",
      label: (
        <div className="font-uregular text-md w-full" onClick={() => onMenuClick("super-admin/settings")}>
          Settings
        </div>
      ),
    });
  }

  if (user?.isSuperAdmin || user?.isRestaurantSwitchEnabled) {
    items.push({
      key: "11",
      label: (
        <div className="font-uregular text-md w-full text-red-600" onClick={() => onMenuClick("switch-restaurant")}>
          Switch Restaurant
        </div>
      ),
    });
  }

  items.push({
    type: "divider",
  });

  if (user?.isRestaurantSwitchEnabled) {
    items.push({
      key: "13",
      label: (
        <div
          className="font-uregular text-md w-full text-red-600"
          onClick={() => onLeaveRestaurant("leave-restaurant")}
        >
          Leave Restaurant
        </div>
      ),
    });
  }

  items.push({
    type: "divider",
  });

  items.push({
    key: "15",
    label: (
      <div className="font-uregular text-md w-full" onClick={logout}>
        Logout
      </div>
    ),
  });

  const menuStyle = `font-ubold text-mdtext-black hover:text-white cursor-pointer`;

  const onMenuClick = (item, flag = "") => {
    let menuUrl = item;
    if (menuUrl.split(" ").length > 0) {
      menuUrl = menuUrl.split(" ").join("-");
    }

    if (flag === "reports") {
      navigate(`/reports/${menuUrl}`);
    } else {
      navigate(`/${menuUrl}`);
    }
  };

  const onBranchChange = async (id) => {
    setNetworkCall(true);
    const resRestaurantInfo = await ApiService.GET_RESTAURANT_INFO(
      { restaurantId: id},
      user.token.token
    );
    const { record } = resRestaurantInfo.payload;

    changeBranch(record);
    ApiService.SWITCH_BRANCH({ restaurantId: id }, user.token.token)
    navigate("/dashboard");
    setIsReloadNeeded(true);
    setNetworkCall(false);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/", { replace: true });
      return;
    }

    setBranch(
      branches.map((i, idx) => ({
        key: `branch-${idx}`,
        label: (
          <div
            className={`font-uregular text-md w-full px-2 py-2 rounded-lg cursor-pointer ${
              restaurantId === i.restaurantId ? "bg-[#572D86] text-white" : ""
            }`}
            onClick={() => onBranchChange(i.restaurantId)}
          >
            {`${i.name}`}
            {i.totalBranches > 1 ? ` (${i.branch})` : ""}
          </div>
        ),
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const handleLogoClick = () => {
    if (isSuperAdmin) {
      navigate("/restaurants");
    } else {
      navigate("/dashboard");
    }
  };

  const qrData = {
    id: restaurantId,
    name: restaurantName,
    slug: restaurantSlug,
    logo: restaurantLogo,
    isRestaurant: true,
    totalTableInRestaurant: totalTableInRestaurant,
  };

  const navigateToQrPage = () => {
    navigate("/restaurant-qr", { state: { qrData } });
    window.location.reload();
  };

  const handleNotificationLoadMore = () => {
    loadNotificationData(user, restaurantId, notificationListPageNo, true);
  };

  const navToNotificationDetail = (notificationItem) => {
    setOpenDrawer(false);

    if (notificationItem.isUnread) {
      markAsReadNotification(user, notificationItem.id);
    }

    navToNotificationDetails(navigate, notificationItem);
  };

  const notificationDrawerOpenHandler = async () => {
    setHasNewNotification(false);
    setOpenDrawer(true);
    // getNotifications();
    loadNotificationData(user, restaurantId, notificationListPageNo);
  };

  /** Super Admin Leave from operating restaurant */
  const onLeaveRestaurant = () => {
    console.log("---------onLeaveRestaurant----");
    const userData = prepareUserDataOnLeaveRestaurant(user);
    setUser(userData);

    navigate("/restaurants");
    setIsReloadNeeded(true);
  };

  useEffect(() => {
    if (isReloadNeeded) {
      setIsReloadNeeded(false);
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }, [isReloadNeeded]);

  return (
    <div className="fixed top-0 left-0 w-full flex bg-yellow py-[16px] items-center z-10">
      {/* Flexible first div */}
      <div className="flex flex-1 items-center">
        <NotificationComponent />
        <img
          className="w-[144px] h-[48px] cursor-pointer"
          src={`https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/TableTap_icon.svg`}
          alt=""
          onClick={handleLogoClick}
        />
        <div className="flex flex-row flex-grow justify-start items-center ml-[13px] bg-gray-300">
          <TopNavMenu currentMenuKey={currentMenuKey} />
        </div>
      </div>

      {/* Fixed width second div */}
      <div className="flex w-[550px] items-center justify-end gap-4 pl-0 pr-4">
        {!user?.isSuperAdmin && (
          <Dropdown
            menu={{
              items: branch,
            }}
            placement="bottom"
            arrow={branch?.length > 0}
            autoAdjustOverflow={true}
          >
            <div className="ml-[16px] text-[18px] font-ubold flex items-center">
              <div className="line-clamp-2 break-all overflow-hidden">{restaurantName}</div>

              <DownOutlined className="w-[12px] h-[12px] ml-[8px] items-center" />
            </div>
          </Dropdown>
        )}

        <div className="flex flex-row items-center justify-end ml-[20px]">
          {isLoggedIn ? (
            <>
              <div className="flex flex-row items-center w-[100px]">
                {!user?.isSuperAdmin && (
                  <img
                    alt="Generate QR"
                    className="w-[24px] h-[24px] cursor-pointer"
                    src={"https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/qr-logo.svg"}
                    onClick={navigateToQrPage}
                  />
                )}
                {!user?.isSuperAdmin && (
                  <div className="relative">
                    <img
                      className="w-[24px] h-[24px] mx-[16px] cursor-pointer"
                      alt=""
                      src="https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/notification.svg"
                      onClick={() => notificationDrawerOpenHandler()}
                    />
                    {hasNewNotification && (
                      <span className="absolute top-0 right-4 w-1 h-1 bg-red-600 rounded-full border-white"></span>
                    )}
                  </div>
                )}
                <div>
                  <Dropdown
                    menu={{
                      items,
                    }}
                    placement="bottomRight"
                    trigger={["click"]}
                    arrow
                  >
                    <img className="w-[24px] h-[24px] cursor-pointer" alt="" src="https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/profile.svg" />
                  </Dropdown>
                </div>
              </div>
            </>
          ) : (
            <div className={menuStyle} onClick={() => onMenuClick("")}>
              Login
            </div>
          )}
        </div>
        <ConfigProvider
          drawer={{
            styles: {
              header: {
                color: `#2EC12B`,
              },
            },
          }}
        >
          <Drawer
            title="Notifications"
            placement={placement}
            closable={false}
            onClose={onCloseDrawer}
            open={openDrawer}
            className="font-uregular ml-0"
            styles={{
              body: {
                padding: "0", // Replace bodyStyle with styles.body
              },
            }}
            loading={notificationInitLoader}
            footer={
              notficationLoadMoreLoader ? (
                <div className="text-center">
                  <Spin />
                </div>
              ) : hasMoreNotifications ? (
                <div
                  onClick={handleNotificationLoadMore}
                  className="flex justify-center items-center p-2 bg-gray-200 hover:bg-gray-300 cursor-pointer"
                >
                  <div>Load More</div>
                  <div>
                    <img
                      className="w-[30px] h-[20px] cursor-pointer"
                      src={`/images/double-arrow-down-black-24dp.svg`}
                      alt=""
                    />
                  </div>
                </div>
              ) : (
                <></>
              )
            }
          >
            {notificationRecords.length > 0 ? (
              notificationRecords.map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-col py-2 pr-3 pl-3 mb-4 ${
                    item.isUnread ? "bg-[#FBE6D8]" : "bg-gray-50"
                  } font-uregular cursor-pointer border-[#d4d4d4] border-[1px] shadow-sm rounded-md`}
                  onClick={() => navToNotificationDetail(item)}
                >
                  <div>
                    <span className="font-ubold">{item.title}</span>{" "}
                    <span className="text-sm text-gray-400">({item.timeText})</span>
                  </div>
                  <div className="pt-2">{item.body}</div>
                  {/* <Divider style={{ margin: '14px 0', borderColor: '#e3e2e1' }}/> */}
                </div>
              ))
            ) : (
              <p className="pl-6 mt-10 text-red-600">No notifications</p>
            )}
          </Drawer>
        </ConfigProvider>
        {/*//New implementation*/}
      </div>
    </div>
  );
}

export default Header;
